import * as types from '../actions/actionTypes';

const initialState = {
  homePageData: {
    preTransactionCounts: {
      byStatus: [],
      byType: []
    },
    transactionCounts: {
      byStatus: [],
      byType: []
    }
  }
}

export default function pageReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_HOME_PAGE_DATA: {
      const { data } = action.payload;

      return {
        ...state,
        homePageData: data
      }
    }

    default:
      return state;
  }
}